import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=e8276332&scoped=true&"
import script from "./FlipBook.vue?vue&type=script&lang=js&"
export * from "./FlipBook.vue?vue&type=script&lang=js&"
import style0 from "./FlipBook.vue?vue&type=style&index=0&id=e8276332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8276332",
  null
  
)

export default component.exports